import { lang } from '../lang.js';
import { guides } from '../view/guides.js';
import { doBeading } from './beading.js';
import { transform } from './transform.js';
import { star } from '../patterns/star.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { menu } from '../menu.js';
import { userimage } from './userimage.js';
import { modes } from '../modes.js';

const transformConfig = [
    {
        panel: 'transform',
        texture: 'rotate_right',
        name: lang.get('rotate right tool tip', 'Rotate right'),
        onClick: () => {
            if (settings.pattern.transform60) {
                transform.transform60('right');
            } else {
                transform.doTransform('right');
            }
        }
    },
    {
        panel: 'transform',
        texture: 'rotate_left',
        name: lang.get('rotate left tool tip', 'Rotate left'),
        onClick: () => {
            if (settings.pattern.transform60) {
                transform.transform60('left');
            } else {
                transform.doTransform('left');
            }
        }
    },
    {
        panel: 'transform',
        texture: 'rotate_180',
        name: lang.get('rotate 180 degrees tool tip', 'Rotate 180 degrees'),
        onClick: () => transform.doTransform('180')
    },
    {
        panel: 'transform',
        texture: 'flip_horizontal',
        name: lang.get('flip horizontal tool tip', 'Flip horizontal'),
        onClick: () => transform.doTransform('horizontal')
    },
    {
        panel: 'transform',
        texture: 'flip_vertical',
        name: lang.get('flip vertical tool tip', 'Flip vertical'),
        onClick: () => transform.doTransform('vertical')
    },
    {
        panel: 'transform',
        texture: 'erase',
        name: lang.get('erase selected tool tip', 'Erase Selected'),
        onClick: () => {
            beads.eraseSelected();
        }
    },
    {
        panel: 'transform',
        texture: 'clone',
        name: lang.get('clone mode', 'Clone mode'),
        onClick: () => {
            const tool = b3.store.state.tools.find(element => element.texture === 'clone');
            modes.cloneActive = !modes.cloneActive;
            tool.isFocused = modes.cloneActive;
        }
    },
];

const viewConfig = [
    {
        panel: 'view',
        texture: 'view_guides',
        name: lang.get('show hide guides', 'Show/hide guides'),
        onClick: () => {
            menu.showGuides(!guides.arr.length);
        }
    },
    {
        panel: 'view',
        texture: 'view_letters',
        name: lang.get('show hide symbols tool tip', 'Show/hide symbols'),
        onClick: () => {
            settings.toggleLetterCodes();
        }
    },
    {
        panel: 'view',
        texture: 'view_inactive',
        name: lang.get('show hide inactive beads tool tip', 'Show/hide inactive beads'),
        onClick: () => {
            settings.toggleInactiveBeads();
        }
    },
    {
        panel: 'view',
        texture: 'view_render',
        name: lang.get('show hide rendering tool tip', 'Show/hide rendering'),
        onClick: () => {
            menu.setSimpleMode(!settings.renderColorOnly);
        }
    },
    {
        panel: 'view',
        texture: 'crosshair',
        name: lang.get('scroll to origin tool tip', 'Scroll to origin'),
        onClick: () => {
            game.cameras.main.scrollX = 0;
            game.cameras.main.scrollY = 0;
        }
    },
];

const rotateConfig = [
    {
        panel: 'rotate',
        texture: '90_left',
        name: lang.get('rotate left', 'Rotate Left'),
        onClick: () => {
            b3.ee.emit('rotateLeft');
        }
    },
    {
        panel: 'rotate',
        texture: '90_right',
        name: lang.get('rotate right', 'Rotate Right'),
        onClick: () => {
            b3.ee.emit('rotateRight');
        }
    },
];

const starConfig = [
    {
        panel: 'star',
        texture: 'star',
        name: lang.get('star panel', 'Star front'),
        onClick: () => star.changeView('F')
    },
    {
        panel: 'star',
        texture: 'star_full',
        name: lang.get('star panel', 'Star back'),
        onClick: () => star.changeView('B')
    },
    {
        panel: 'star',
        texture: 'square1',
        name: lang.get('star panel', 'Warped square 1'),
        onClick: () => star.changeView(1)
    },
    {
        panel: 'star',
        texture: 'square2',
        name: lang.get('star panel', 'Warped square 2'),
        onClick: () => star.changeView(2)
    },
    {
        panel: 'star',
        texture: 'square3',
        name: lang.get('star panel', 'Warped square 3'),
        onClick: () => star.changeView(3)
    },
    {
        panel: 'star',
        texture: 'square4',
        name: lang.get('star panel', 'Warped square 4'),
        onClick: () => star.changeView(4)
    },
    {
        panel: 'star',
        texture: 'square5',
        name: lang.get('star panel', 'Warped square 5'),
        onClick: () => star.changeView(5)
    },
];

const beadingConfig = [
    {
        panel: 'beading',
        texture: 'arrow',
        name: lang.get('beading mode move row back', 'Move beading row back'),
        onClick: () => doBeading.next(true)
    },
    {
        panel: 'beading',
        texture: 'arrow_down',
        name: lang.get('beading mode move row forwards', 'Move beading row'),
        onClick: () => doBeading.next()
    },
    {
        panel: 'beading',
        texture: 'rotate',
        name: lang.get('beading mode change direction', 'Change direction'),
        onClick: () => doBeading.changeOrientation()
    },
];

const userImage = [
    {
        panel: 'userImage',
        texture: 'trash',
        name: lang.get('delete image tool tip', 'Delete image'),
        onClick: () => userimage.remove()
    },
    {
        panel: 'userImage',
        texture: 'bake',
        name: lang.get('convert to beads tool tip', 'Convert to beads'),
        onClick: () => menu.showBake()
    },
];

export const panelTools = beadingConfig
    .concat(starConfig)
    .concat(transformConfig)
    .concat(viewConfig)
    .concat(rotateConfig)
    .concat(userImage);
